import React from 'react'

import { Field } from 'formik'

import { Form, Col, Button } from '_zari/core'

import { TiposTablaPersonalizadaConstant } from 'constants/index'

import * as TablaPersonalizadaService from 'services/tablasPersonalizadas.service'

import { NuevoActualizarTablaPersonalizadaModal } from 'sharedComponents/modals'

const IdSubServicio2FormGroup = ({ iError, iTouched, fIsSubmitting, vIdServicio, vIdSubServicio1 }) => {
  const [subServicios2, setSubServicios2] = React.useState([])
  const [mostrarModalCrud, setMostrarModalCrud] = React.useState(false)

  React.useEffect(() => {
    if (vIdSubServicio1) {
      TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.TALLERSUBSERVICIO2, {
        _idSubServicio1: vIdSubServicio1
      }).then(({ data }) => {
        setSubServicios2(data)
      })
    } else {
      setSubServicios2([])
    }
  }, [vIdSubServicio1])

  const onSuccess = React.useCallback(async () => {
    TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.TALLERSUBSERVICIO2, {
      _idSubServicio1: vIdSubServicio1
    }).then(({ data }) => {
      setSubServicios2(data)
    })
    setMostrarModalCrud(false)
  }, [vIdSubServicio1])

  return (
    <>
      <Form.Group>
        <Form.Label text='SUB SERVICIO 2' htmlFor='select-idSubServicio2' md={2} alignRightAt='md' />
        <Col md={10}>
          <Form.InputGroup>
            <Field name='_idSubServicio2'>
              {({ field }) => (
                <Form.Select {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='select-idSubServicio2'>
                  <option key='seleccionar' value=''>
                    Seleccionar
                  </option>
                  {subServicios2.map(x => (
                    <option key={x._id} value={x._id}>
                      {x.nombre}
                    </option>
                  ))}
                </Form.Select>
              )}
            </Field>
            <Form.InputGroup.Append>
              <Button onClick={() => setMostrarModalCrud(true)}>+</Button>
            </Form.InputGroup.Append>
          </Form.InputGroup>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
      {mostrarModalCrud && (
        <NuevoActualizarTablaPersonalizadaModal
          handleClose={e => setMostrarModalCrud(false)}
          show={mostrarModalCrud}
          modalData={{
            _idServicio: vIdServicio,
            _idSubServicio1: vIdSubServicio1
          }}
          onSuccess={onSuccess}
          tipoTabla={TiposTablaPersonalizadaConstant.TALLERSUBSERVICIO2}
        />
      )}
    </>
  )
}

export default React.memo(IdSubServicio2FormGroup)
